import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = {
  id: "navigationPlaceholder",
  style: {"padding-top":"80px"}
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-7" }
const _hoisted_5 = { style: {"font-size":"2em","font-weight":"300","color":"#33475b"} }
const _hoisted_6 = { class: "container" }
const _hoisted_7 = ["href"]

import { ref, computed, onMounted, watch } from 'vue'
    import { useId } from '@common/composables'
    import { useRouter } from 'vue-router'
    import { useAdminConnectorDetailsPage } from '@Integrations/Connectors/pages-core'
    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminConnectorDetailsPage',
  setup(__props) {

    const router = useRouter()
    const id = useId()

    const {
        useCurrentUserQuery,
        useConnectorDetailsQuery,
        useDeleteConnectorCommand,
        usePermanentDeleteConnectorCommand,
    } = useAdminConnectorDetailsPage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { modelConnectorDetailsQueryV1, runConnectorDetailsQueryV1 } = useConnectorDetailsQuery(id)
    const tid = computed(() => modelConnectorDetailsQueryV1.value?.OrganizationUnitId)
    const name = computed(() => modelConnectorDetailsQueryV1.value?.Name)
    const isDeleted = computed(() => modelConnectorDetailsQueryV1.value?.IsDeleted)

    const { invokeDeleteConnectorCommandV1, succeedDeleteConnectorCommandV1 } = useDeleteConnectorCommand(id, tid, userId)
    const { invokePermanentDeleteConnectorCommandV1, succeedPermanentDeleteConnectorCommandV1 } = usePermanentDeleteConnectorCommand(id)

    function handleDeleteConnectorCommandV1() {
        if (confirm(`Do you really want to delete connector ${name.value}?`)) invokeDeleteConnectorCommandV1()
    }

    function handlePermanentDeleteConnectorCommandV1() {
        if (confirm(`Do you really want to PERMANENTLY delete connector ${name.value}?`)) invokePermanentDeleteConnectorCommandV1()
    }

    onMounted(() => {
        runCurrentUserQueryV1()
        runConnectorDetailsQueryV1()
    })

    watch(name, () => document.title = name.value)

    watch([succeedDeleteConnectorCommandV1], () => runConnectorDetailsQueryV1())

    watch(succeedPermanentDeleteConnectorCommandV1, (val) => val ? router.push(`/admin/integrations/connectors/manage/${tid.value}`) : null)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AdminNavigationV2, { tid: tid.value }, null, 8 /* PROPS */, ["tid"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", _hoisted_5, _toDisplayString(name.value), 1 /* TEXT */),
          (!isDeleted.value)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                onClick: handleDeleteConnectorCommandV1,
                role: "button",
                class: "btn btn-link btn-sm"
              }, [...(_cache[0] || (_cache[0] = [
                _createElementVNode("i", { class: "fa-regular fa-trash-can" }, null, -1 /* CACHED */),
                _createTextVNode(" Delete ", -1 /* CACHED */)
              ]))]))
            : (_openBlock(), _createElementBlock("a", {
                key: 1,
                onClick: handlePermanentDeleteConnectorCommandV1,
                role: "button",
                class: "btn btn-link btn-sm"
              }, [...(_cache[1] || (_cache[1] = [
                _createElementVNode("i", {
                  class: "fa fa-remove",
                  "aria-hidden": "true"
                }, null, -1 /* CACHED */),
                _createTextVNode(" Permanently delete ", -1 /* CACHED */)
              ]))]))
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "col-lg-5 col-sm-6 text-right" }, null, -1 /* CACHED */))
      ])
    ]),
    _cache[5] || (_cache[5] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 30px"} }, null, -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("a", {
        href: `/#/admin/integrations/connectors/configure/${_unref(id)}`
      }, "Configure connector", 8 /* PROPS */, _hoisted_7),
      _cache[3] || (_cache[3] = _createTextVNode(" ", -1 /* CACHED */)),
      _createElementVNode("span", null, "(" + _toDisplayString(name.value) + ")", 1 /* TEXT */),
      _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1 /* CACHED */))
    ])
  ]))
}
}

})